import React from 'react'
import { useBreakpoints } from 'hooks'
import ProfileButton from './ProfileButton'

const ProfileStickyButton = ({ children, ...rest }) => {
  const { md } = useBreakpoints()

  return md ? (
    <div
      className="sticky right-0 z-15 w-full h-14 mb-5 bg-black pt-3 md:pt-0 md:h-0"
      style={{ top: md ? `calc(100vh - 75px)` : '100px' }}
    >
      <ProfileButton className="w-full bg-azureBlue" {...rest}>
        {children}
      </ProfileButton>
    </div>
  ) : null
}

export default ProfileStickyButton
